import React, { useEffect, useState } from "react";
import { eventRoomStore } from "@/stores/event";
import { useParams } from "react-router-dom";
import WelcomeLoader from "../WelcomeLoader/WelcomeLoader";
import Welcome from "../welcome/Welcome";
import WelcomeIt from "../welcome/Welcome.it";
import GuideWelcome from "../Guide/Welcome";
import Cookies from "js-cookie";
import { updateUserToken } from "@/utils/api/services/auth.services";

type ParamTypes = {
  visit: any;
  [key: string]: any;
};

function Visit() {
  const [isLoading, setIsLoading] = useState(true);
  const [visitDetails, setVisitDetails] = useState<any>();
  const [isGuideView, setIsGuideView] = useState(false);
  const lang = new URLSearchParams(window.location.search).get("lang");

  const param = useParams<ParamTypes>();
  const visit = param?.visit;

  const resolveCurrentRole = (user: any) => {
    return eventRoomStore.resolveUserRole(user);
  };

  useEffect(() => {
    const getVisitDetails = async () => {
      const visitDetails = await eventRoomStore.fetchVisitDetails(visit);
      if (visitDetails?.status == 423) {
        window.location.href = "/error/invalid";
      } else if (visitDetails.status == 200) {
        const details = visitDetails.visit as any;
        const publicRole = String(details?.user_role || "").toLowerCase();

        if (Cookies.get("token")) {
          if (details?.guide_details?.groups?.includes("Guide")) {
            const currentUser = await eventRoomStore.getAuthorizedCurrentUser();
            const currentRole = resolveCurrentRole(currentUser);

            if (currentRole === "guide" && currentUser?.id && details?.guide_details?.id && currentUser.id !== details.guide_details.id) {
              window.location.href = "/error/access-denied";
              return;
            }

            setIsGuideView(currentRole === "guide");
          }
        } else if (publicRole === "guide") {
          setIsGuideView(true);
        }
        setVisitDetails(details);
        setIsLoading(false);
      } else {
        if (Cookies.get("token")) {
          if (visitDetails.status == 401) {
            //If it's guide and if token is expired
            await updateUserToken(Cookies.get("token"));
            getVisitDetails();
          } else if (visitDetails.status == 400) {
            window.location.href = "/error/access-denied";
          } else {
            eventRoomStore.logout();
          }
        } else {
          window.location.href = "/404";
        }
      }
    };
    if (visit) {
      setIsLoading(true);
      getVisitDetails();
    } else {
      window.location.href = "/404";
    }
  }, []);
  return (
    <>
      {isLoading ? (
        <WelcomeLoader />
      ) : (
        <>
          {isGuideView ? (
            <GuideWelcome visit={visitDetails} visit_id={visit} />
          ) : (lang == "it" ? (
            <WelcomeIt visit={visitDetails} visit_id={visit} />
          ) : (
            <Welcome visit={visitDetails} visit_id={visit} />
          ))}
        </>
      )}
    </>
  );
}
export default Visit;
